import { Component } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-no-content",
  templateUrl: "./no-content.component.html",
  styles: ``,
})
export class NoContentComponent {}
